import { render, staticRenderFns } from "./taohuali.vue?vue&type=template&id=835d3a72&scoped=true"
import script from "./taohuali.vue?vue&type=script&lang=js"
export * from "./taohuali.vue?vue&type=script&lang=js"
import style0 from "./taohuali.vue?vue&type=style&index=0&id=835d3a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835d3a72",
  null
  
)

export default component.exports